export default "__VITE_ASSET__fa5b689d__"